import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginApi } from "../services/authApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";
import mainContext from "../context/mainContext";

const CLIENT_ID = "694655215480-voa8p9mardcmets01d91rgbeuna584d6.apps.googleusercontent.com";

export default function Login({ getBoxListInFirstLoad }) {
  const nav = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [loginInfo, setLoginInfo] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [googleLoading, setGoogleLoading] = React.useState(false);
  const { handleUserType, handleIsAuthed, isAuthed } = useContext(mainContext);

  const handleGoogleLogin = () => {
    setGoogleLoading(true);
    const loginUri = `https://app.umlang.com/app/auth/google?action=login&source=leitner`;
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(loginUri)}&response_type=id_token&scope=openid%20email&nonce=${Date.now()}`;
  };

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginApi({ loginInfo, password, device: "web" });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        handleUserType(resData["data"]["data"][0]["type_user"]);
        handleIsAuthed(true);
        await getBoxListInFirstLoad();
        toast.success("خوش آمدید");
        nav("/home");
      } else {
        toast.error("ورود ناموفق بود");
        handleIsAuthed(false);
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"] || "مشکلی وجود دارد";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (isAuthed) nav("/home");
  }, []);

  return (
    <div className="container" style={{ maxWidth: 440 }}>
      <div style={{ textAlign: "center", margin: "32px 0 24px" }}>
        <img
          src="https://leitnerpwa.umlang.com/icons/logo128.png"
          alt="لایتنر"
          style={{ width: 64, height: 64, borderRadius: 18, marginBottom: 8 }}
        />
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>ورود به لایتنر</h1>
        <p style={{ color: "var(--text-secondary)", fontSize: 13, margin: "4px 0 0" }}>
          با حساب کاربری اوملنگ وارد شوید
        </p>
      </div>
      <div className="card" style={{ padding: 24 }}>
        <form onSubmit={onSubmit}>
          <label className="label">نام کاربری / شماره تلفن / ایمیل</label>
          <input
            className="input"
            value={loginInfo}
            onChange={(e) => setLoginInfo(e.target.value)}
            placeholder="0989123456789"
            required
            autoFocus
          />
          <label className="label" style={{ marginTop: 16 }}>
            رمز عبور
          </label>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
          <button className="btn" disabled={loading} style={{ width: "100%", marginTop: 20 }}>
            {loading ? "...در حال ورود" : "ورود"}
          </button>
          <div style={{ textAlign: "center", margin: "16px 0", color: "var(--text-secondary)", fontSize: 13 }}>یا</div>
          <button type="button" className="btn btn-outline" disabled={googleLoading}
            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
            onClick={handleGoogleLogin}>
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {googleLoading ? "در حال اتصال..." : "ورود با گوگل"}
          </button>
        </form>
      </div>
      <div style={{ textAlign: "center", fontSize: 13, color: "var(--text-secondary)", marginTop: 16, lineHeight: 2 }}>
        <p>
          چنانچه قبلا ثبت نام نکرده اید، ابتدا از طریق{" "}
          <a href="https://app.umlang.com/" style={{ color: "var(--primary-light)", fontWeight: 600 }}>
            اپلیکیشن اوملنگ
          </a>{" "}
          یا{" "}
          <a href="https://umlang.com/" style={{ color: "var(--primary-light)", fontWeight: 600 }}>
            وبسایت اوملنگ
          </a>{" "}
          ثبت نام کنید.
        </p>
        <p>
          پس از ثبت نام حتما <strong style={{ color: "var(--accent)" }}>نام کاربری و کلمه عبور</strong> خود را تنظیم کنید.
        </p>
      </div>
      {loading && (
        <div className="center" style={{ marginTop: 16, gap: 8 }}>
          <div className="spinner small"></div>
          <span style={{ color: "var(--text-secondary)" }}>در حال اعتبارسنجی</span>
        </div>
      )}
    </div>
  );
}
